"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OtherProduce = function OtherProduce(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M18 5.5H6C5.93433 5.49995 5.86929 5.51285 5.8086 5.53796C5.74792 5.56307 5.69278 5.5999 5.64634 5.64634C5.5999 5.69278 5.56307 5.74792 5.53796 5.8086C5.51285 5.86929 5.49995 5.93433 5.5 6V18C5.5 18.1326 5.55268 18.2598 5.64645 18.3536C5.74021 18.4473 5.86739 18.5 6 18.5H18C18.1326 18.5 18.2598 18.4473 18.3536 18.3536C18.4473 18.2598 18.5 18.1326 18.5 18V6C18.5 5.86739 18.4473 5.74021 18.3536 5.64645C18.2598 5.55268 18.1326 5.5 18 5.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 17.5C10.7275 17.5 9.49444 17.0588 8.51082 16.2516C7.5272 15.4443 6.85391 14.321 6.60566 13.073C6.35742 11.825 6.54958 10.5295 7.14941 9.40733C7.74924 8.28512 8.71962 7.40562 9.89521 6.91867C11.0708 6.43172 12.3789 6.36746 13.5965 6.73683C14.8142 7.1062 15.8661 7.88635 16.5731 8.94436C17.28 10.0024 17.5982 11.2728 17.4735 12.5391C17.3488 13.8054 16.7888 14.9893 15.8891 15.8891C15.3795 16.4014 14.7735 16.8076 14.1059 17.0841C13.4383 17.3606 12.7225 17.502 12 17.5ZM12 7.5C10.9589 7.5 9.95 7.86099 9.14522 8.52146C8.34044 9.18193 7.78957 10.101 7.58646 11.1221C7.38336 12.1432 7.54058 13.2031 8.03135 14.1213C8.52212 15.0395 9.31607 15.759 10.2779 16.1575C11.2398 16.5559 12.31 16.6084 13.3063 16.3062C14.3025 16.004 15.1632 15.3657 15.7416 14.5001C16.32 13.6344 16.5804 12.595 16.4783 11.5589C16.3763 10.5228 15.9182 9.5542 15.182 8.81803C14.7651 8.39886 14.2692 8.06653 13.723 7.84029C13.1768 7.61406 12.5912 7.49839 12 7.5Z",
    fill: props.foregroundColor
  }));
};

OtherProduce.defaultProps = {
  altText: "Other Produce",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
OtherProduce.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = OtherProduce;
exports.default = _default;